import React, { useContext, useEffect } from "react";
import { AppContext } from "./index";
import { mesAno, clBasic, bkSubMain } from "./general";

export default function GraficoHist({ tipo, prioridad, categoria, estado, persona, w, h }) {
  let { firebase } = useContext(AppContext);
  let color = [
    ["#CED8F6", "#5882FA"],
    ["#CECEF6", "#5858FA"],
  ];

  const Scanvas = {
    position: "relative",
    background: bkSubMain,
    height: `${(h / 2).toString()}px`,
    borderRadius: "40px",
    margin: "10px 0px 10px 0px"

  };

  useEffect(() => {
    let cMes = document.getElementById("barMes").getContext("2d");
    let cAcum = document.getElementById("barAcum").getContext("2d");
    let { maximo, abiertos, cerrados, maximoAcum, abiertosAcum, cerradosAcum, meses } = firebase.datosGraficoHist(
      tipo,
      prioridad,
      categoria,
      estado,
      persona
    );
    // reduzco h y w para que el grafico tenga menor protagonismo

    bar(cMes, abiertos, cerrados, maximo, meses, "Evolución mensual de incidentes", color[0]);
    bar(cAcum, abiertosAcum, cerradosAcum, maximoAcum, meses, "Evolución acumulada de incidentes", color[1]);
  });

  function bar(c, abiertos, cerrados, maximo, meses, titulo, color) {
    const lmax = h * 0.8 / 4;
    const xinicial = 40;
    const ybase = (h * 2.56) / 8;
    const anchoBarra = w * 0.8 / 16;
    const anchoTotal = w * 0.8 - xinicial * 2;
    const gapBarras = (anchoTotal - anchoBarra * 2 * meses.length) / (meses.length - 1);
    const etiquetas = ["abiertos", "cerrados"];

    //titulo
    c.beginPath();
    c.lineWidth = "1";
    c.clearRect(0, 0, w, h / 2);
    c.font = "900 3vh Arial";
    c.fillStyle = "clBasic";
    c.fillText(titulo, w * 0.8 / 2 - c.measureText(titulo).width / 2, 30);

    // referencias
    let coordXRef = [xinicial + anchoBarra * 3, xinicial + anchoBarra * 6]
    for (let i = 0; i < etiquetas.length; i++) {
      c.beginPath();
      c.fillStyle = color[i];
      c.fillRect(coordXRef[i], ybase + 50, 25, 10);
      c.font = "1.6vh Arial";
      c.fillStyle = clBasic;
      c.fillText(etiquetas[i], coordXRef[i] + 30, ybase + 60);
    }

    // barras
    c.beginPath();
    c.lineWidth = anchoBarra;
    let xi = xinicial + 12;
    for (let m = meses.length - 1; m >= 0; m--) {
      c.beginPath();
      c.moveTo(xi, ybase);
      c.lineTo(xi, ybase - (abiertos[m] * lmax) / maximo);
      c.strokeStyle = color[0];
      c.stroke();
      c.beginPath();
      c.moveTo(xi + anchoBarra, ybase);
      c.lineTo(xi + anchoBarra, ybase - (cerrados[m] * lmax) / maximo);
      c.strokeStyle = color[1];
      c.stroke();
      // etiquetas
      c.font = "1.8vh Arial";
      c.fillStyle = "clBasic";
      c.fillText(mesAno(meses[m]), xi, ybase + 20);
      if (abiertos[m]) c.fillText(abiertos[m], xi, ybase - (abiertos[m] * lmax) / maximo);
      if (cerrados[m]) c.fillText(cerrados[m], xi + anchoBarra, ybase - (cerrados[m] * lmax) / maximo);
      xi = xi + anchoBarra * 2 + gapBarras;
    }
  }

  return (
    <>
      <div style={Scanvas}>
        <div style={Sgrafico}>
          <canvas id="barMes" height={(h / 2).toString() + "px"} width={w.toString() + "px"} />
        </div>
      </div>
      <div style={Scanvas}>
        <div style={Sgrafico}>
          <canvas id="barAcum" height={(h / 2).toString() + "px"} width={w.toString() + "px"} />
        </div>
      </div>
    </>
  );
}

const Sgrafico = {
  width: "80%",
  height: "80%",
  margin: "auto"
}
